<div [formGroup]="form" [patchFormGroupValues]="config()" class="flex flex-col">
  <bo-widget-base-filter
    formControlName="filter"
    [showEnergySource]="false"
  ></bo-widget-base-filter>
</div>
